// src/redirectHandler.js
import { SITE_CONFIG } from './config';

const handleRedirect = () => {
  const path = window.location.pathname;
  const affiliateTag = encodeURIComponent(SITE_CONFIG.affiliateTag);

  // Detect if the user is on a mobile device
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // Helper function to inject meta tags for app deep linking
  const injectMetaTags = (url, customScheme) => {
    // iOS: Apple Smart App Banner with custom scheme
    const iOSMeta = document.createElement('meta');
    iOSMeta.name = 'apple-itunes-app';
    iOSMeta.content = `app-id=297606951, app-argument=${customScheme}`;
    document.head.appendChild(iOSMeta);

    // Android: Hint at universal link for App Link resolution
    const androidLink = document.createElement('link');
    androidLink.rel = 'alternate';
    androidLink.href = url;
    document.head.appendChild(androidLink);
  };

  // Helper function to show continue button
  const showContinueButton = (url) => {
    let timeLeft = 2.0; // Start at 2 seconds

    const buttonDiv = document.createElement('div');
    buttonDiv.id = 'continue-button';
    buttonDiv.style.cssText = `
      position: fixed;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      padding: 40px 35px;
      background: rgba(255, 255, 255, 0.98);
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
      z-index: 1000;
      width: 90%;
      max-width: 450px;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    `;

    buttonDiv.innerHTML = `
      <h2 style="margin: 0 0 20px; font-size: 28px; font-weight: 700; color: #1a1a1a; line-height: 1.2;">Redirecting to Amazon</h2>
      <p id="countdown-text" style="margin: 0 0 25px; font-size: 17px; color: #555; line-height: 1.4;">
        You'll be taken to Amazon in <span id="countdown-timer" style="font-weight: 700; color: #007bff; font-size: 19px;">2.0</span> seconds
      </p>
      <button onclick="window.location.href='${url}'"
        style="
          padding: 14px 40px;
          font-size: 17px;
          font-weight: 600;
          background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
          color: white;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
          min-width: 180px;
        "
        onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 6px 20px rgba(0, 123, 255, 0.4)'"
        onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 15px rgba(0, 123, 255, 0.3)'"
      >Continue Now</button>
      <p style="margin: 25px 0 0; font-size: 13px; color: #777; line-height: 1.5; padding: 0 10px;">
        As an Amazon Associate, we earn from qualifying purchases. You will be redirected to Amazon.com where prices and availability are subject to change.
      </p>
    `;

    document.body.appendChild(buttonDiv);

    // Add responsive styles for mobile
    const styleSheet = document.createElement('style');
    styleSheet.textContent = `
      @media (max-width: 480px) {
        #continue-button {
          width: 85% !important;
          padding: 30px 25px !important;
          top: 50% !important;
        }
        #continue-button h2 {
          font-size: 24px !important;
        }
        #continue-button button {
          width: 100% !important;
          padding: 14px 20px !important;
        }
      }
    `;
    document.head.appendChild(styleSheet);

    // Update countdown timer
    const timerElement = document.getElementById('countdown-timer');
    const countdownInterval = setInterval(() => {
      timeLeft -= 0.1;
      if (timeLeft <= 0) {
        clearInterval(countdownInterval);
        timerElement.textContent = '0.0';
      } else {
        timerElement.textContent = timeLeft.toFixed(1);
      }
    }, 100); // Update every 100ms
  };

  // Handle /paid-ad/<ASIN>
  const paidAdMatch = path.match(/^\/paid-ad\/([^/]+)$/);
  if (paidAdMatch) {
    const asin = encodeURIComponent(paidAdMatch[1]);
    const amazonUrl = `https://www.amazon.com/dp/${asin}?tag=${affiliateTag}`;
    const customScheme = `com.amazon.mobile.shopping.web://www.amazon.com/dp/${asin}?tag=${affiliateTag}`;

    // Inject meta tags and show continue button
    injectMetaTags(amazonUrl, customScheme);
    showContinueButton(amazonUrl);

    // Delay redirect to allow interaction with Smart App Banner or Continue button
    setTimeout(() => {
      window.location.href = amazonUrl;
    }, 2000);

    return;
  }

  // Handle /haul-ad/<ASIN>
  const haulAdMatch = path.match(/^\/haul-ad\/([^/]+)$/);
  if (haulAdMatch) {
    const asin = encodeURIComponent(haulAdMatch[1]);
    const amazonUrl = `https://www.amazon.com/dp/${asin}?s=bazaar&tag=${affiliateTag}`;
    const customScheme = `com.amazon.mobile.shopping.web://www.amazon.com/dp/${asin}?s=bazaar&tag=${affiliateTag}`;

    // Inject meta tags and show continue button
    injectMetaTags(amazonUrl, customScheme);
    showContinueButton(amazonUrl);

    // Delay redirect to allow interaction with Smart App Banner or Continue button
    setTimeout(() => {
      window.location.href = amazonUrl;
    }, 2000);

    return;
  }

  // Handle /business-ad/<ASIN>
  const bizAdMatch = path.match(/^\/business-ad\/([^/]+)$/);
  if (bizAdMatch) {
    const asin = encodeURIComponent(bizAdMatch[1]);
    const amazonUrl = `https://www.amazon.com/dp/${asin}?tag=${affiliateTag}`;

    if (isMobile) {
      // Mobile: Try custom scheme
      const customScheme = `com.amazon.mobile.shopping.web://www.amazon.com/dp/${asin}?tag=${affiliateTag}`;
      window.location.href = customScheme;

      // Fallback to web URL if app doesn't open (after 2 seconds)
      setTimeout(() => {
        if (document.visibilityState === 'visible') {
          window.location.href = amazonUrl;
        }
      }, 2000);
    } else {
      // Non-mobile: Use web URL
      window.location.href = amazonUrl;
    }
    return;
  }

  // Handle /offer-ad/<ASIN>&qty=<QTY>&OID=<OFFERLISTINGID>
  const offerAdMatch = path.match(/^\/offer-ad\/([^&]+)&qty=(\d+)&OID=(.+)$/);
  if (offerAdMatch) {
    const asin = encodeURIComponent(offerAdMatch[1]);
    const qty = encodeURIComponent(offerAdMatch[2]);
    const offerListingId = offerAdMatch[3]; // Already encoded from URL

    const amazonUrl = `https://www.amazon.com/gp/product/handle-buy-box/ref=dp_start-bbf_1_glance?ASIN=${asin}&quantity=${qty}&submit.buy-now=Submit&account-linking=yes&dropdown-selection=add-new&dropdown-selection-ubb=add-new&offeringID=${offerListingId}&tag=${affiliateTag}`;
    const customScheme = `com.amazon.mobile.shopping.web://www.amazon.com/gp/product/handle-buy-box/ref=dp_start-bbf_1_glance?ASIN=${asin}&quantity=${qty}&submit.buy-now=Submit&account-linking=yes&dropdown-selection=add-new&dropdown-selection-ubb=add-new&offeringID=${offerListingId}&tag=${affiliateTag}`;

    // Inject meta tags and show continue button
    injectMetaTags(amazonUrl, customScheme);
    showContinueButton(amazonUrl);

    // Delay redirect like paid-ad
    setTimeout(() => {
      window.location.href = amazonUrl;
    }, 2000);

    return;
  }

  // Handle /qty-ad/<ASIN>&qty=<QTY>
  const qtyAdMatch = path.match(/^\/qty-ad\/([^&]+)&qty=(\d+)$/);
  if (qtyAdMatch) {
    const asin = encodeURIComponent(qtyAdMatch[1]);
    const qty = encodeURIComponent(qtyAdMatch[2]);
    const amazonUrl = `https://www.amazon.com/dp/${asin}?qty=${qty}&tag=${affiliateTag}`;

    if (isMobile) {
      // Mobile: Try custom scheme with quantity
      const customScheme = `com.amazon.mobile.shopping.web://www.amazon.com/dp/${asin}?qty=${qty}&tag=${affiliateTag}`;
      window.location.href = customScheme;

      // Fallback to web URL if app doesn't open
      setTimeout(() => {
        if (document.visibilityState === 'visible') {
          window.location.href = amazonUrl;
        }
      }, 2000);
    } else {
      // Non-mobile: Use web URL
      window.location.href = amazonUrl;
    }
    return;
  }

  // Handle /merchant-ad/<MERCHANT_ID> (regular)
  const merchantAdMatch = path.match(/^\/merchant-ad\/([^/]+)$/);
  if (merchantAdMatch) {
    const merchantId = encodeURIComponent(merchantAdMatch[1]);
    const amazonUrl = `https://www.amazon.com/s?i=merchant-items&me=${merchantId}&s=price-asc-rank&tag=${affiliateTag}`;
    const customScheme = `com.amazon.mobile.shopping.web://www.amazon.com/s?i=merchant-items&me=${merchantId}&s=price-asc-rank&tag=${affiliateTag}`;

    // Inject meta tags and show continue button
    injectMetaTags(amazonUrl, customScheme);
    showContinueButton(amazonUrl);

    // Delay redirect like paid-ad
    setTimeout(() => {
      window.location.href = amazonUrl;
    }, 2000);

    return;
  }

  // Handle /merchant-business/<MERCHANT_ID> (business - app deep link on mobile)
  const merchantBusinessMatch = path.match(/^\/merchant-business\/([^/]+)$/);
  if (merchantBusinessMatch) {
    const merchantId = encodeURIComponent(merchantBusinessMatch[1]);
    const amazonUrl = `https://www.amazon.com/s?i=merchant-items&me=${merchantId}&s=price-asc-rank&tag=${affiliateTag}`;

    if (isMobile) {
      // Mobile: Try custom scheme
      const customScheme = `com.amazon.mobile.shopping.web://www.amazon.com/s?i=merchant-items&me=${merchantId}&s=price-asc-rank&tag=${affiliateTag}`;
      window.location.href = customScheme;

      // Fallback to web URL if app doesn't open
      setTimeout(() => {
        if (document.visibilityState === 'visible') {
          window.location.href = amazonUrl;
        }
      }, 2000);
    } else {
      // Non-mobile: Use web URL
      window.location.href = amazonUrl;
    }
    return;
  }

  // Handle /used-ad/<ASIN>
  const usedAdMatch = path.match(/^\/used-ad\/([^/]+)$/);
  if (usedAdMatch) {
  const asin = encodeURIComponent(usedAdMatch[1]);
  const amazonUrl = `https://www.amazon.com/gp/offer-listing/${asin}/ref=dp_olp_ALL_mbc?ie=UTF8&condition=ALL&tag=${affiliateTag}&m=A2L77EE7U53NWQ`;
  const customScheme = `com.amazon.mobile.shopping.web://www.amazon.com/gp/offer-listing/${asin}/ref=dp_olp_ALL_mbc?ie=UTF8&condition=ALL&tag=${affiliateTag}&m=A2L77EE7U53NWQ`;

  // Inject meta tags and show continue button
  injectMetaTags(amazonUrl, customScheme);
  showContinueButton(amazonUrl);

  // Delay redirect like paid-ad
  setTimeout(() => {
    window.location.href = amazonUrl;
  }, 2000);

  return;
  }

};

export default handleRedirect;
